













import { Component, Prop, Vue } from 'vue-property-decorator';
import { SliderMarker } from './types/SliderTypes';
import VueSmartSliderPip from './VueSmartSliderPip.vue';

@Component({
  components: { VueSmartSliderPip },
})
export default class VueSmartSliderPips extends Vue {
  name = 'VueSmartSliderPips';

  @Prop({ type: Array, required: false, default: [] }) readonly marker!: Array<SliderMarker>;

  @Prop({ type: Number, required: false, default: 0 }) readonly width!: number;

  @Prop({ type: Number, required: false, default: 100 }) readonly max!: number;
}
